module.exports = "/static/assets/7a6a5c794d6fe77611613ddfdf905506.png";